const S = { fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };

function House({ x, y, s = 1, lime = false }) {
  return (
    <g transform={`translate(${x} ${y}) scale(${s})`} stroke={lime ? "#C6EE5A" : "rgba(255,255,255,0.55)"} strokeWidth={1.4 / s} {...S}>
      <path d="M-30 -12 L0 -38 L30 -12" />
      <path d="M-24 -16 V22 H24 V-16" />
      <path d="M-7 22 V4 H7 V22" />
      <rect x="-19" y="-7" width="8" height="8" />
      <rect x="11" y="-7" width="8" height="8" />
    </g>
  );
}

const MOTIFS = {
  large: (
    <>
      <House x={88} y={78} s={1.25} />
      <House x={196} y={90} s={0.7} lime />
      <path d="M130 98 C 150 112, 165 112, 176 100" stroke="#C6EE5A" strokeWidth="1.2" strokeDasharray="3 4" {...S} />
      <path d="M172 96 l5 4 -6 3" stroke="#C6EE5A" strokeWidth="1.2" {...S} />
    </>
  ),
  keys: (
    <>
      <House x={100} y={80} s={1.2} />
      {[0, 1, 2, 3].map((i) => (
        <rect key={i} x={168 + i * 14} y={104 - i * 12} width="8" height={8 + i * 12} rx="2" fill={i === 3 ? "#C6EE5A" : "rgba(255,255,255,0.25)"} />
      ))}
    </>
  ),
  horizon: (
    <>
      <path d="M20 112 H240" stroke="rgba(255,255,255,0.25)" strokeWidth="1" {...S} />
      <path d="M150 112 A 32 32 0 0 1 214 112" stroke="#C6EE5A" strokeWidth="1.4" {...S} />
      {[0, 1, 2, 3, 4].map((i) => (
        <path key={i} d={`M${182 + Math.cos(Math.PI * (0.1 + i * 0.2)) * 42} ${112 - Math.sin(Math.PI * (0.1 + i * 0.2)) * 42} l${Math.cos(Math.PI * (0.1 + i * 0.2)) * 8} ${-Math.sin(Math.PI * (0.1 + i * 0.2)) * 8}`} stroke="#C6EE5A" strokeWidth="1.2" {...S} />
      ))}
      <House x={84} y={84} s={1.1} />
    </>
  ),
  village: (
    <>
      <path d="M10 110 C 70 96, 160 120, 250 104" stroke="rgba(255,255,255,0.22)" strokeWidth="1" {...S} />
      <House x={70} y={86} s={0.8} />
      <House x={135} y={78} s={1.05} lime />
      <House x={200} y={90} s={0.7} />
      {[30, 238].map((x) => (
        <g key={x} stroke="rgba(255,255,255,0.45)" strokeWidth="1.2" {...S}>
          <path d={`M${x} 108 V88`} />
          <circle cx={x} cy={80} r="10" />
        </g>
      ))}
    </>
  ),
  small: (
    <>
      <g transform="translate(130 86)" stroke="rgba(255,255,255,0.6)" strokeWidth="1.4" {...S}>
        <path d="M-52 -6 L0 -30 L52 -6" />
        <path d="M-46 -9 V22 H46 V-9" />
        <path d="M-7 22 V4 H7 V22" />
        <rect x="-36" y="-2" width="14" height="9" />
        <rect x="22" y="-2" width="14" height="9" />
      </g>
      <path d="M130 108 C 128 118, 120 124, 108 128" stroke="#C6EE5A" strokeWidth="1.3" strokeDasharray="2 4" {...S} />
      <circle cx="210" cy="60" r="12" stroke="#C6EE5A" strokeWidth="1.2" {...S} />
      <path d="M204 60 h12 M210 54 v12" stroke="#C6EE5A" strokeWidth="1.2" {...S} />
    </>
  ),
};

export function PersonaArt({ motif }) {
  return (
    <svg viewBox="0 0 260 130" className="h-full w-full" aria-hidden="true">
      <defs>
        <radialGradient id={`pa-${motif}`} cx="0.5" cy="0.6" r="0.6">
          <stop offset="0" stopColor="rgba(150,193,31,0.22)" />
          <stop offset="1" stopColor="rgba(150,193,31,0)" />
        </radialGradient>
      </defs>
      <rect width="260" height="130" fill={`url(#pa-${motif})`} />
      {MOTIFS[motif]}
    </svg>
  );
}
